"use client";

import { useRequestCommunitiesAdminUsers } from "./useRequestCommunitiesAdminUsers";

/**
 * Lists pending community join requests via
 * `GET /communities/{community_id}/admin/users?filter_by_is_admin=pending`.
 */
export const useRequestCommunitiesAdminUsersPending = ({
  communityId,
  enabled,
  search,
}: {
  communityId: number;
  enabled?: boolean;
  search?: string;
}) =>
  useRequestCommunitiesAdminUsers({
    enabled,
    params: {
      path: { community_id: communityId },
      query: {
        filter_by_is_admin: "pending",
        search,
      },
    },
  });
